import { type INextExecution } from '@recargas-dominicanas/core/types';
import { BankScrapingManagerApi } from '@recargas-dominicanas/core/api';
import { BaseStore } from './BaseStore';

interface State {
  id: number;
  nextExecution?: INextExecution;
}

class Store extends BaseStore<State> {

  constructor() {
    super('bankScrapingManager');
  }

  getNextExecution() {
    return this.findById(1, 'nextExecution');
  }

  async fetchNextExecution() {

    const nextExecution = await BankScrapingManagerApi.getNextExcecution();

    if (this.exists(1)) {
      this.update(1, 'nextExecution', nextExecution);
    } else {
      this.add('nextExecution', { ...nextExecution, id: 1 });
    }
  }
}

export const BankScrapingManagerStore = new Store();
